import { useState } from 'react'
import { ActionIcon, Group, Image, Text } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import { chatApi } from '@/api/chat'
import type { ChatAttachment } from '@/api/chat'

function humanSize(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`
  return `${(n / 1024 / 1024).toFixed(1)} MB`
}

export function AttachmentCard({ att }: { att: ChatAttachment }) {
  // Falha de carregamento da imagem (URL presignada expirada/erro) → cai no chip.
  const [imgFailed, setImgFailed] = useState(false)

  const open = async () => {
    try {
      const { url } = await chatApi.attachmentDownloadUrl(att.id)
      window.open(url, '_blank', 'noopener')
    } catch {
      // best-effort; silencioso
    }
  }

  // Preview inline para imagens: o backend presigna `att.url` só para imagens
  // raster (troca de evidências/prints como no WhatsApp). Clique abre em tela
  // cheia (nova aba). Fallback para o chip se a URL faltar ou falhar ao carregar.
  const isImage = !!att.mime_type && att.mime_type.startsWith('image/')
  if (isImage && att.url && !imgFailed) {
    return (
      <Image
        src={att.url}
        alt={att.filename}
        radius="md"
        fit="contain"
        onClick={open}
        onError={() => setImgFailed(true)}
        style={{
          maxWidth: 320,
          maxHeight: 240,
          marginTop: 6,
          cursor: 'pointer',
          border: '1px solid var(--mantine-color-default-border)',
        }}
      />
    )
  }

  return (
    <Group
      gap="xs"
      wrap="nowrap"
      style={{
        border: '1px solid var(--mantine-color-default-border)',
        borderRadius: 8,
        padding: '6px 10px',
        maxWidth: 320,
        marginTop: 6,
      }}
    >
      <Text size="sm" style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={att.filename}>
        {att.filename}
      </Text>
      <Text size="xs" c="dimmed">{humanSize(att.size_bytes)}</Text>
      <ActionIcon variant="subtle" onClick={open} aria-label={`Baixar ${att.filename}`}>
        <IconDownload size={16} />
      </ActionIcon>
    </Group>
  )
}
